import * as utils from '@utils/form';
import { SLUG_RULE, TITLE_RULE } from '@constants';

export const FORM_FIELD = {
  PARENT_BOOK: {
    name: 'parentBook',
    label: 'Parent book:',
    placeholder: 'Type to search a book',
    serialize: utils.relatedEntitySerializer,
    deserialize: utils.makeRelatedEntityDeserializer(['id', 'title']),
    deserializeError: utils.deserializeErrorRelatedField,
    rules: [{ required: true, message: 'Parent book is required' }],
  },
  TITLE: {
    name: 'title',
    label: 'Title:',
    rules: [{ required: true, message: 'Title is required' }, TITLE_RULE],
  },
  SLUG: {
    name: 'slug',
    label: 'Slug:',
    rules: [{ required: true, message: 'Page slug is required' }, SLUG_RULE],
  },
  SEO_DESCRIPTION: {
    name: 'seoDescription',
    label: 'SEO description:',
    rules: [{ required: true, message: 'SEO description is required' }],
  },
  TEXT: {
    name: 'text',
    label: 'Text:',
    rules: [{ required: true, message: 'Text is required' }],
  },
  SECTIONS: {
    name: 'sections',
    label: 'Related sections',
  },
};

export const FORM_FIELDS = Object.values(FORM_FIELD);

export const DEFAULT_VALUES = {
  [FORM_FIELD.SECTIONS.name]: ['Name', 'Commencements', 'Headquarters, Officers and Applicable Law'],
};
